import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, Instagram, MessageCircle } from "lucide-react";
import { api, inr, SOCIALS } from "../lib/api";
import { Footer } from "../components/Footer";

export const Confirmation = () => {
  const { id } = useParams();
  const [booking, setBooking] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.booking(id).then(setBooking).catch(() => {});
  }, [id]);

  return (
    <div data-testid="confirmation-page" className="min-h-[70vh]">
      <div className="max-w-3xl mx-auto px-6 py-20 md:py-28 text-center">
        <motion.div
          initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: "spring", stiffness: 200, damping: 15 }}
          className="w-16 h-16 rounded-full bg-terracotta text-cream flex items-center justify-center mx-auto mb-8"
        >
          <Check size={28} />
        </motion.div>
        <p className="text-xs uppercase tracking-[0.2em] text-terracotta mb-4">Seat reserved</p>
        <h1 className="font-serif font-light text-4xl md:text-6xl text-ink tracking-tighter leading-none">You&rsquo;re on the list.</h1>
        <p className="text-muted-earth text-lg font-light mt-6 max-w-xl mx-auto leading-relaxed">
          {booking ? (
            <>We&rsquo;ve reserved <strong className="text-ink">{booking.quantity} ticket{booking.quantity > 1 ? "s" : ""}</strong> for <strong className="text-ink">{booking.event_title}</strong>. Our team will reach out on <strong className="text-ink">{booking.phone}</strong> with the secure payment link to confirm your spot.</>
          ) : (
            "We've reserved your spot. Our team will reach out shortly with the secure payment link to confirm."
          )}
        </p>

        {booking && (
          <div data-testid="booking-summary" className="mt-10 border border-ink/15 bg-cream text-left p-7 border-l-2 border-l-terracotta">
            <div className="flex justify-between py-2 text-sm"><span className="text-muted-earth uppercase tracking-[0.12em]">Booking ID</span><span className="text-ink font-mono">{booking.id.slice(0, 8)}</span></div>
            <div className="flex justify-between py-2 text-sm"><span className="text-muted-earth uppercase tracking-[0.12em]">Attendee</span><span className="text-ink">{booking.name}</span></div>
            <div className="flex justify-between py-2 text-sm"><span className="text-muted-earth uppercase tracking-[0.12em]">Amount due</span><span className="font-serif text-xl text-ink">{inr(booking.amount)}</span></div>
            <div className="flex justify-between py-2 text-sm"><span className="text-muted-earth uppercase tracking-[0.12em]">Status</span><span className="text-terracotta uppercase tracking-[0.12em]">Awaiting payment</span></div>
          </div>
        )}

        <p className="mt-10 text-sm text-muted-earth">While you wait, join the community for updates:</p>
        <div className="flex items-center justify-center gap-4 mt-5">
          <a href={SOCIALS.whatsapp} target="_blank" rel="noreferrer" data-testid="confirm-whatsapp" className="flex items-center gap-2 border border-ink/25 px-5 py-3 rounded-full text-xs uppercase tracking-[0.15em] hover:border-terracotta transition-colors"><MessageCircle size={15} /> WhatsApp</a>
          <a href={SOCIALS.instagram} target="_blank" rel="noreferrer" data-testid="confirm-instagram" className="flex items-center gap-2 border border-ink/25 px-5 py-3 rounded-full text-xs uppercase tracking-[0.15em] hover:border-terracotta transition-colors"><Instagram size={15} /> Instagram</a>
        </div>
        <Link to="/events" className="inline-block mt-10 text-xs uppercase tracking-[0.15em] text-terracotta">Browse more experiences &rarr;</Link>
      </div>
      <Footer />
    </div>
  );
};
